var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgPhoneWhiteFill = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.725,
    height: 15.56,
    viewBox: "0 0 9.725 15.56",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "phone-fill",
    d: "M3,1.945A1.945,1.945,0,0,1,4.945,0H10.78a1.945,1.945,0,0,1,1.945,1.945v11.67A1.945,1.945,0,0,1,10.78,15.56H4.945A1.945,1.945,0,0,1,3,13.615Zm5.835,10.7a.973.973,0,1,1-.973-.973A.973.973,0,0,1,8.835,12.643Z",
    transform: "translate(-3)",
    fill: "#c9c9c9",
    fillRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPhoneWhiteFill);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI5LjcyNSIgaGVpZ2h0PSIxNS41NiIgdmlld0JveD0iMCAwIDkuNzI1IDE1LjU2Ij4KICA8cGF0aCBpZD0icGhvbmUtZmlsbCIgZD0iTTMsMS45NDVBMS45NDUsMS45NDUsMCwwLDEsNC45NDUsMEgxMC43OGExLjk0NSwxLjk0NSwwLDAsMSwxLjk0NSwxLjk0NXYxMS42N0ExLjk0NSwxLjk0NSwwLDAsMSwxMC43OCwxNS41Nkg0Ljk0NUExLjk0NSwxLjk0NSwwLDAsMSwzLDEzLjYxNVptNS44MzUsMTAuN2EuOTczLjk3MywwLDEsMS0uOTczLS45NzNBLjk3My45NzMsMCwwLDEsOC44MzUsMTIuNjQzWiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTMpIiBmaWxsPSIjYzljOWM5IiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KPC9zdmc+Cg==";